const THAI_MONTHS = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค."
];

// เดือนย้อนหลังที่แสดง ไม่นับเดือนนี้
const PAST_MONTHS = 6;

const startOfDay = d => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export function thaiMonthLabel(year, month) {
  const d = new Date(year, month, 1);
  const be = String((d.getFullYear() + 543) % 100).padStart(2, "0");
  return THAI_MONTHS[d.getMonth()] + " " + be;
}

// back = 0 คือเดือนนี้ (ถึงวันนี้), 1 คือเดือนที่แล้ว ...
function monthShortcut(back, prefix, now) {
  return {
    // Vuex cache getter ไว้ตลอดอายุแท็บ — คำนวณ label และช่วงวันตอนใช้งานจริง
    // เพื่อให้เปลี่ยนตามเดือนแม้เปิดค้างข้ามเดือน
    get text() {
      const today = now();
      const label = thaiMonthLabel(today.getFullYear(), today.getMonth() - back);
      return prefix ? prefix + " (" + label + ")" : label;
    },
    onClick() {
      const today = startOfDay(now());
      const y = today.getFullYear();
      const m = today.getMonth();
      if (back === 0) return [new Date(y, m, 1), today];
      return [new Date(y, m - back, 1), new Date(y, m - back + 1, 0)];
    }
  };
}

export function buildDateRangeShortcuts(now = () => new Date()) {
  const shortcuts = [
    {
      text: "วันนี้",
      onClick() {
        const today = startOfDay(now());
        return [today, today];
      }
    },
    {
      text: "เมื่อวาน",
      onClick() {
        const today = now();
        const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
        return [yesterday, yesterday];
      }
    },
    monthShortcut(0, "เดือนนี้", now),
    monthShortcut(1, "เดือนที่แล้ว", now)
  ];
  for (let back = 2; back <= PAST_MONTHS; back++) {
    shortcuts.push(monthShortcut(back, null, now));
  }
  return shortcuts;
}
